var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "展示全路径" } },
        [
          _c("el-switch", {
            model: {
              value: _vm.activeData["show-all-levels"],
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "show-all-levels", $$v)
              },
              expression: "activeData['show-all-levels']",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "可否筛选" } },
        [
          _c("el-switch", {
            model: {
              value: _vm.activeData.filterable,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "filterable", $$v)
              },
              expression: "activeData.filterable",
            },
          }),
        ],
        1
      ),
      [
        _c("el-divider", [_vm._v("选项")]),
        _vm.activeData.config.dataType === "static"
          ? _c("el-tree", {
              attrs: {
                data: _vm.treeData,
                "expand-on-click-node": false,
                "node-key": "id",
                "default-expand-all": "",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c("div", { staticClass: "custom-tree-node" }, [
                        _c("span", [_vm._v(_vm._s(node.label))]),
                        _c("span", { staticClass: "node-operation" }, [
                          data.level < 4
                            ? _c("i", {
                                staticClass: "el-icon-plus",
                                attrs: { title: "添加" },
                                on: {
                                  click: function ($event) {
                                    return _vm.append(data)
                                  },
                                },
                              })
                            : _vm._e(),
                          _c("i", {
                            staticClass: "el-icon-delete",
                            attrs: { title: "删除" },
                            on: {
                              click: function ($event) {
                                return _vm.remove(node, data)
                              },
                            },
                          }),
                        ]),
                      ])
                    },
                  },
                ],
                null,
                false,
                492392357
              ),
            })
          : _vm._e(),
        _vm.activeData.config.dataType === "static"
          ? _c(
              "div",
              { staticStyle: { "margin-left": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "padding-bottom": "0" },
                    attrs: {
                      icon: "el-icon-circle-plus-outline",
                      type: "text",
                    },
                    on: { click: _vm.addTreeItem },
                  },
                  [_vm._v(" 添加 ")]
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: { click: _vm.batchEditTreeItem },
                      },
                      [_vm._v("批量编辑")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c("el-divider"),
        _c("treeNode-dialog", {
          attrs: { visible: _vm.dialogVisible, title: "添加选项" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            commit: _vm.addNode,
          },
        }),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "批量编辑",
              visible: _vm.batchDialogVisible,
              "close-on-click-modal": false,
              "close-on-press-escape": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.batchDialogVisible = $event
              },
            },
          },
          [
            _vm.batchDialogVisible
              ? _c("batch-treeNode-dialog", {
                  ref: "batch",
                  attrs: { treeData: _vm.treeData },
                  on: { close: _vm.batchAddNode },
                })
              : _vm._e(),
            _c(
              "div",
              { attrs: { slot: "footer" }, slot: "footer" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handelConfirm },
                  },
                  [_vm._v(" 确定 ")]
                ),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.batchDialogVisible = false
                      },
                    },
                  },
                  [_vm._v(" 取消 ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }